module.exports = __webpack_public_path__ + "static/media/069-woman-15.262aed8c.svg";